export default "/images/vendor/primevue/resources/hue.png?f8505bd4d6f3e3aa435b72d1c045d4a7";